import { render, staticRenderFns } from "./SidOverlay.vue?vue&type=template&id=7ff6ad6b"
import script from "./SidOverlay.vue?vue&type=script&lang=js"
export * from "./SidOverlay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports